var _rect, _rect2, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDepToArr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 32,
    viewBox: "0 0 84 32",
    fill: "#BCBEC0",
    stroke: "#BCBEC0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 15,
    width: 60,
    height: 2,
    fill: "#BCBEC0",
    stroke: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    fillOpacity: 0.01,
    stroke: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6866 17.0754C24.2067 17.0379 26 16.7134 26 15.9987C26 15.2853 24.2067 14.9635 22.6866 14.9247C21.1691 14.8872 20.0987 14.9247 20.0987 14.9247L12.5141 6H11.3164L15.2386 13.6502C15.7321 14.6015 13.952 14.7695 13.952 14.7695L9.25642 15.3305C9.14102 15.2297 7.36227 12.9652 7.36227 12.9652H6L7.48828 15.6265C6.80515 15.779 6.48945 15.8759 6.48945 15.9987C6.48945 16.124 6.80517 16.2197 7.48828 16.3709L6 19.0348H7.36227C7.36227 19.0348 9.14102 16.7703 9.25642 16.6682L13.952 17.2278C13.952 17.2278 15.7321 17.3985 15.2386 18.3497L11.3164 26H12.5141L20.0987 17.0754C20.0987 17.0754 21.1691 17.1128 22.6866 17.0754Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 16,
    r: 5.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDepToArr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DepToArr.2af52723597d1e7bfe769b0a5ff5db98.svg";